import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Table, Spin, Col, Button, Row } from 'antd'
import axios from 'axios'

import AuthorizeComponent from './../../../auth/components/AuthorizeComponent'
import { GeneralStyledContent } from '../../../../styled/common-styled'
import LangContext from 'modules/shared/context/langContext'
import {
    declareColumns,
    cameraColumns,
    filesColumn,
} from '../../gpsvendorpayingreport/components/declareColumns'

class Previewtable extends Component {
    constructor(props) {
        super(props)
        this.state = {
            dataPreview: [],
            loadPreview: false,
            filter: '',
            header: '',
            loading: false,
        }

        this.columns = [
            {
                title: (
                    <LangContext.Consumer>
                        {i18n => i18n.b.boxnumber}
                    </LangContext.Consumer>
                ),
                dataIndex: 'device_code',
                key: 'device_code',
                width: 140,
            },
            {
                title: 'SIM Number',
                dataIndex: 'sim_no',
                key: 'sim_no',
                width: 150,
            },
            {
                title: (
                    <LangContext.Consumer>
                        {i18n => i18n.v.vehicleNumber}
                    </LangContext.Consumer>
                ),
                dataIndex: 'vehicle_code',
                key: 'vehicle_code',
                width: 120,
            },
            {
                title: (
                    <LangContext.Consumer>
                        {i18n => i18n.p.plateNoCar}
                    </LangContext.Consumer>
                ),
                dataIndex: 'plate_no',
                key: 'plate_no',
                width: 120,
            },
            {
                title: (
                    <LangContext.Consumer>{i18n => i18n.p.plants}</LangContext.Consumer>
                ),
                dataIndex: 'plant',
                key: 'plant',
                width: 180,
            },
            {
                title: (
                    <LangContext.Consumer>
                        {i18n => i18n.b.businesspartner}
                    </LangContext.Consumer>
                ),
                dataIndex: 'company_partner',
                key: 'company_partner',
                width: 200,
            },
            {
                title: (
                    <LangContext.Consumer>
                        {i18n => i18n.g.gpsVendor}
                    </LangContext.Consumer>
                ),
                dataIndex: 'vendor_name',
                key: 'vendor_name',
                width: 180,
            },
            {
                title: 'GPS',
                children: [
                    {
                        title: (
                            <LangContext.Consumer>
                                {i18n => i18n.p.percentage_working_day}
                            </LangContext.Consumer>
                        ),
                        dataIndex: 'percentage_gps_performance',
                        key: 'percentage_gps_performance',
                        width: 130,
                    },
                    {
                        title: (
                            <LangContext.Consumer>
                                {i18n => i18n.i.is_pay_gps}
                            </LangContext.Consumer>
                        ),
                        dataIndex: 'is_pay_gps',
                        key: 'is_pay_gps',
                        width: 150,
                    },
                    ...declareColumns('gps_declare'),
                ],
            },
            {
                title: (
                    <LangContext.Consumer>
                        {i18n => i18n.gpsUsage.drumSensor}
                    </LangContext.Consumer>
                ),
                children: [
                    {
                        title: 'Sensor(%)',
                        dataIndex: 'percent_sensor',
                        key: 'percent_sensor',
                        width: 100,
                    },
                    {
                        title: (
                            <LangContext.Consumer>
                                {i18n => i18n.i.is_pay_sensor}
                            </LangContext.Consumer>
                        ),
                        dataIndex: 'is_pay_sensor',
                        key: 'is_pay_sensor',
                        width: 150,
                    },
                    ...declareColumns('sensor_declare'),
                ],
            },
            cameraColumns,
            filesColumn,
            {
                title: 'Card Reader(%)',
                dataIndex: 'percent_card_reader',
                key: 'percent_card_reader',
                width: 120,
            },
            {
                title: (
                    <LangContext.Consumer>
                        {i18n => i18n.p.percentage_working}
                    </LangContext.Consumer>
                ),
                dataIndex: 'percentage_working_day',
                key: 'percentage_working_day',
                width: 120,
            },
            {
                title: (
                    <LangContext.Consumer>
                        {i18n => i18n.a.amount_money}
                    </LangContext.Consumer>
                ),
                dataIndex: 'amount_money',
                key: 'amount_money',
                width: 120,
            },
        ]
    }

    handleMenuClick = () => {
        let self = this
        if (self.state.filter !== '' && self.state.header !== '') {
            let data = {
                ...self.state.filter,
                type_file: 'excel',
                ...self.state.header,
            }
            self.setState({ loading: true })

            fetch(
                `${process.env.REACT_APP_API_REPORT_GOLANG}/reports/go/gpsvendorpayingsummary`,
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        date_start: data.date_start,
                        date_end: data.date_end,
                        vendor_list: data.vendor_list,
                        sort_by: data.sort_by,
                        vehicle_visibility: data.vehicle_visibility,
                        type_file: data.type_file,
                    }),
                },
            )
                .then(response => response.json())
                .then(res => {
                    self.setState({ loading: false }, () =>
                        window.location.assign(res.result),
                    )
                })
                .catch(e => this.setState({ loading: false }))
        }
    }

    componentDidMount() {
        if (
            localStorage.getItem('gpsvendorpayingsummaryreport-filter') != null &&
            localStorage.getItem('gpsvendorpayingsummaryreport-header') != null
        ) {
            let self = this
            let filter = localStorage.getItem('gpsvendorpayingsummaryreport-filter')
            let header = localStorage.getItem('gpsvendorpayingsummaryreport-header')
            self.setState({
                filter: JSON.parse(filter),
                header: JSON.parse(header),
                loadPreview: true,
            })
            axios
                .post(
                    `${process.env.REACT_APP_API_REPORT_GOLANG}/reports/go/gpsvendorpayingsummary`,
                    JSON.parse(filter),
                    JSON.parse(header),
                )
                .then(function (response) {
                    if (Array.isArray(response.data)) {
                        self.setState({
                            dataPreview: response.data,
                            loadPreview: false,
                        })
                    }
                })
                .catch(function (error) {
                    console.log(error)
                })
        }
    }

    componentWillUnmount() {
        localStorage.removeItem('gpsvendorpayingsummaryreport-filter')
        localStorage.removeItem('gpsvendorpayingsummaryreport-header')
    }

    render() {
        const columns = this.columns.map(col => col)

        return (
            <AuthorizeComponent
                {...this.props}
                matching_name="gpsVendorPayingSummaryReport"
            >
                <Spin spinning={this.state.loading}>
                    <Spin spinning={this.state.loadPreview}>
                        <GeneralStyledContent>
                            <Row
                                gutter={24}
                                type="flex"
                                justify="end"
                                style={{ height: '38px' }}
                            >
                                <Col xs={9} sm={4} md={3} lg={2} xl={2}>
                                    <Button
                                        type="primary"
                                        block
                                        onClick={() => this.handleMenuClick()}
                                    >
                                        <LangContext.Consumer>
                                            {i18n => i18n.r.report}
                                        </LangContext.Consumer>
                                    </Button>
                                </Col>
                            </Row>

                            <Table
                                scroll={{ x: 6520, y: `${window.innerHeight - 300}px` }}
                                dataSource={this.state.dataPreview}
                                columns={columns}
                                bordered
                            />
                        </GeneralStyledContent>
                    </Spin>
                </Spin>
            </AuthorizeComponent>
        )
    }
}

const mapStateToProps = ({ auth }) => ({
    auth,
})

export default connect(mapStateToProps, null)(Previewtable)
